import { useEffect, useState } from 'react'
import { Form, Input, Button, Card, Typography } from 'antd'
import axios from 'axios'
import { BUBBLES } from './Data'
import { SendOtp, ValidateOtp } from "../API's/UserApi"
import { toast } from 'react-toastify'
import Navbar from './Navbar'
import Footer from './Footer'
import { useNavigate } from 'react-router-dom'

const { Title } = Typography

export default function MemberLogin() {
  const [form] = Form.useForm()
  const navigate = useNavigate()

  const [mobile, setMobile] = useState('')
  const [otp, setOtp] = useState('')
  const [otpSent, setOtpSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [timeLeft, setTimeLeft] = useState(0)

  const [otpMessage, setOtpMessage] = useState('')

  // SEND OTP API
  const sendOtp = async () => {
    if (!mobile) {
      return
    }

    try {
      setLoading(true)

      const res = await axios.post(`${SendOtp}?mobileNo=${mobile}`)
      if (res.data.message === 'OTPSEND') {
        setOtpSent(true)
        // start 3 min timer
        setTimeLeft(180)
        setOtpMessage(res.data.otp)
        toast.success('OTP has been send to your mobile number')
      } else if (res.data === 'NOTFOUND') {
        toast.warn('Data not found!')
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!timeLeft) return

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(timer)
  }, [timeLeft])

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
    const s = seconds % 60

    return `${m}:${s < 10 ? '0' : ''}${s}`
  }

  // LOGIN API

  const handleLogin = async () => {
    if (!mobile || !otp) {
      return
    }

    try {
      setLoading(true)

      const res = await axios.post(
        `${ValidateOtp}?mobileNo=${mobile}&otp=${otp}`,
      )

      if (res.data.message === 'VERIFIED') {
        const userData = res.data.data

        // store token
        sessionStorage.setItem('authToken', userData.token)
        sessionStorage.setItem('userName', userData.name)
        sessionStorage.setItem('mobileNo', userData.mobileNo)
        sessionStorage.setItem('role', userData.role)

        // Dispatch event so App re-renders
        window.dispatchEvent(new Event('storage'))

        // store full user object (optional)
        sessionStorage.setItem('userData', JSON.stringify(userData))

        toast.success('Login Successfully')

        navigate('/user/user-bookslot', { replace: true })
      } else if (res.data.message === 'INVALID') {
        toast.warn('Invalid OTP !')
      } else if (res.data === ' EXPIRED') {
        toast.error('OTP Expired!')
      } else if (res.data.message === ' NOTFOUND') {
        toast.warn('Data not found!')
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    navigate('/')
  }

  return (
    <>
      {/* <Navbar openAdmin={()=>setShowLogin(true)} /> */}

      <div style={styles.container} className="p-2 p-md-0">
        {BUBBLES.map((b, i) => (
          <div
            key={i}
            className="hero-bubble"
            style={{
              width: b.w,
              height: b.w,
              left: b.l,
              top: b.t,
              animationDelay: b.d,
            }}
          />
        ))}

        <Card style={styles.card}>
          <h2 className="login-title"> User Login</h2>

          <Form layout="vertical" onFinish={handleLogin}>
            <Form.Item
              label="Mobile Number"
              name="mobile"
              rules={[
                { required: true, message: 'Please enter mobile number' },
                {
                  pattern: /^[0-9]{10}$/,
                  message: 'Mobile number must be 10 digits',
                },
              ]}
            >
              <Input
                size="large"
                placeholder="Enter mobile number"
                maxLength={10}
                value={mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '')
                  setMobile(value)
                }}
              />
            </Form.Item>

            {/* SEND OTP BUTTON */}

            {!otpSent && (
              <div style={{ display: 'flex', gap: 10 }}>
                <Button danger size="large" block onClick={handleCancel}>
                  Cancel
                </Button>
                <Button
                  type="primary"
                  size="large"
                  block
                  loading={loading}
                  onClick={sendOtp}
                >
                  Send OTP
                </Button>
              </div>
            )}

            {/* OTP INPUT */}

            {otpSent && (
              <>
                <Form.Item
                  label="Enter OTP"
                  name="otp"
                  style={{ marginTop: 20 }}
                  rules={[
                    { required: true, message: 'Please enter OTP' },
                    { len: 6, message: 'OTP must be 6 digits' },
                  ]}
                >
                  <Input.OTP
                    length={6}
                    size="large"
                    value={otp}
                    onChange={(value) => setOtp(value)}
                  />
                </Form.Item>

                {otpMessage && (
                  <p
                    style={{
                      marginTop: 10,
                      color: '#555',
                      textAlign: 'center',
                    }}
                  >
                   OTP : {otpMessage}
                  </p>
                )}

                {otpSent && timeLeft > 0 && (
                  <p style={{ marginTop: 10, color: '#888' }}>
                    OTP expires in {formatTime(timeLeft)}
                  </p>
                )}

                {otpSent && timeLeft === 0 && (
                  <>
                    <p style={{ marginTop: 10, color: 'red' }}>
                      ( OTP expired, Please resend )
                      <span>
                        <Button type="link" onClick={sendOtp}>
                          Resend OTP
                        </Button>
                      </span>
                    </p>
                  </>
                )}

                {/* {timeLeft === 0 && (
                  <Button type="link" onClick={sendOtp}>
                    Resend OTP
                  </Button>
                )} */}

                <Form.Item>
                  <div style={{ display: 'flex', gap: 10 }}>
                    <Button danger size="large" block onClick={handleCancel}>
                      Cancel
                    </Button>

                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      block
                      loading={loading}
                      disabled={timeLeft === 0}
                    >
                      Login
                    </Button>
                  </div>
                </Form.Item>
              </>
            )}
          </Form>
        </Card>
      </div>

      {/* <Footer/> */}
    </>
  )
}

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg,#0ea5e9,#2563eb)',
  },

  card: {
    width: 380,
    borderRadius: 10,
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
  },
}
